<template>
  <div class="number-selector">
    <label v-if="label" class="form-label" style="font-size: 0.875rem">
      <span v-if="required" class="text-danger">*</span> {{ label }}
      <Tooltip v-if="tooltip" :text="tooltip" placement="top">
        <SvgIcon iconName="icon-icon_universe_circle_question" class="ms-1"></SvgIcon>
      </Tooltip>
    </label>
    <div
      class="seat-input-group d-flex h-[36px]"
      :style="{ 'border-color': '#d8e8ff', 'background-color': '#f5faff' }"
    >
      <button
        class="btn btn-outline-secondary w-[3rem] m-0 d-flex justify-content-center align-items-center"
        type="button"
        @click="decrease"
        :disabled="modelValue <= min"
        style="font-size: 1.2rem"
      >
        <img src="../../../assets/icons/circle_minus.svg" width="16px" alt="minus" />
      </button>
      <input
        type="text"
        class="form-control form-number text-center h-[36px]"
        :value="modelValue"
        @input="inputValue"
        @change="updateValue($event.target.value)"
        style="font-size: 1rem;box-sizing: border-box;"
        :required="required"
      />
      <button
        class="btn btn-outline-secondary  w-[3rem] m-0 d-flex justify-content-center align-items-center"
        type="button"
        @click="increase"
        :disabled="modelValue >= max"
        style="font-size: 1.2rem"
      >
        <img src="../../../assets/icons/circle_add.svg" width="16px" alt="add" />
      </button>
    </div>
    <small v-if="errorMsg" class="text-danger">{{ errorMsg }}</small>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import SvgIcon from './SvgIcon.vue'

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: 1
  },
  min: {
    type: Number,
    default: 1
  },
  max: {
    type: Number,
    default: 100
  },
  step: {
    type: Number,
    default: 1
  },
  label: {
    type: String,
    default: ''
  },
  tooltip: {
    type: String,
    default: ''
  },
  required: {
    type: Boolean,
    default: false
  },
  errorMsg: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:modelValue'])
const errorMsg = ref('')

const increase = () => {
  if (props.modelValue < props.max) {
    emit('update:modelValue', Number(props.modelValue) + props.step)
  }
}

const decrease = () => {
  if (props.modelValue > props.min) {
    emit('update:modelValue', Number(props.modelValue) - props.step)
  }
}


const inputValue = event => {
  const intValue = event.target.value.replace(/[^0-9]/g, '')
  if(intValue !== event.target.value) {
    event.target.value = intValue
  }
  emit('update:modelValue', Number(intValue))
}

const updateValue = value => {
  let numValue = Number(value)
  if (isNaN(numValue)) {
    emit('update:modelValue', '')
    return
  }

  if (numValue > props.max) {
    numValue = props.max
  } else if (numValue < props.min) {
    numValue = props.min
  }
  errorMsg.value = props.errorMsg
  emit('update:modelValue', numValue)
}
</script>

<style scoped>
 .form-number {
  background-color: #F5FAFF !important;
  border-color: #D8E8FF;
  font-size: 0.875rem;
  color: #343b46;
  width: 100%;
  
}
 
</style>
